//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
